<template>
  <section id="ceptinel-present-financial-services-forum" class="text-justify">
    <br />
    <p v-html="$t('content')"></p>
    <b-carousel :indicator-inside="false">
      <b-carousel-item v-for="(img,i) in images" :key="i">
        <img class="w100" :src="getImgUrl(img)" alt="media-presence-1.png" />
      </b-carousel-item>
    </b-carousel>
  </section>
</template>
<script>
export default {
  name: "ceptinel-present-financial-services-forum",
  data() {
    return {
      images: [
        "1698343540897",
        "1698343543039",
        "1698343544058",
        "1698343544060",
        "1698343544127",
      ],
    };
  },
  methods: {
    getImgUrl(pic) {
      return require("@/assets/news/ceptinel-present-financial-services-forum/" + pic + ".jpg");
    },
  },
};
</script>
<i18n>
{
    "es": {
        "title": "Ceptinel dice presente en Financial Services Forum",
        "content": "El pasado 23 y 24 de Octubre, Abdiel Castrellón, Regional Manager de Ceptinel estuvo presente en Puerto Rico FINANCIAL SERVICES FORUM. Dicha convocatoria tuvo por objetivo reunir a los principales líderes de la industria y funcionarios gubernamentales, quienes compartieron ideas sobre las últimas tendencias y regulaciones, cumplimiento, IA, AML, ciberseguridad y mucho más.",
        "more":"Ver más"
    },
    "en": {
        "title": "Ceptinel is present at the Financial Services Forum",
        "content": "On October 23 and 24, Abdiel Castrellón, Regional Manager of Ceptinel was present at Puerto Rico FINANCIAL SERVICES FORUM. This call aimed to bring together top industry leaders and government officials, who shared ideas on the latest trends and regulations, compliance, AI, AML, cybersecurity and much more.",
        "more":"See more"
    },
    "pt": {
        "title": "Ceptinel marca presença no Fórum de Serviços Financeiros",
        "content": "Nos dias 23 e 24 de outubro, Abdiel Castrellón, Gerente Regional da Ceptinel esteve presente no FÓRUM DE SERVIÇOS FINANCEIROS de Porto Rico. Esta teleconferência teve como objetivo reunir os principais líderes da indústria e funcionários do governo, que compartilharam ideias sobre as últimas tendências e regulamentações, conformidade, IA, AML, segurança cibernética e muito mais.",
        "more":"Ver mais"
    }
}
</i18n>
